/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { IReactionDisposer, computed, reaction } from 'mobx';
import React, { Component } from 'react';
import { UploadSource } from '@src/framework/frame-pc/components/paging-selection/constants';

import IndexWrapper from './index-wrapper';
import { IPagingSelectionManager, IPagingSelectionManagerData } from '@src/slide/application/service/paging-selection/core/paging-selection-manager.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

export default class Root extends Component<{}, {
    visible: boolean,
    data: IPagingSelectionManagerData,
}> {
    visibleReaction: IReactionDisposer;
    dataReaction: IReactionDisposer;

    constructor(props, context) {
        super(props, context);
        this.state = {
            visible: false,
            data: {
                presentationStr: '',
                title: '',
                useCurrentSlideIndex: false,
                source: UploadSource.LOCAL,
            },
        };

        this.visibleReaction = reaction(
            () => this.pagingSelectionManager?.visible,
            (visible) => {
                this.setState({ visible: !!visible });
            },
        );

        this.dataReaction = reaction(
            () => this.pagingSelectionManager?.data,
            (data) => {
                // @ts-ignore
                this.setState({ data });
            },
        );
    }

    @computed get pagingSelectionManager(): IPagingSelectionManager | undefined {
        return this.getAppServices().editableServiceLayer?.pagingSelectionManager;
    }

    onClose() {
        this.pagingSelectionManager?.setVisible(false);
        this.pagingSelectionManager?.updateData({
            presentationStr: '',
            title: '',
        });
    }

    componentWillUnmount() {
        this.visibleReaction();
        this.dataReaction();
    }
    render() {
        return (
            this.state.visible
                ? <IndexWrapper {...this.props}
                    data={this.state.data}
                    onClose={this.onClose.bind(this)} />
                : null
        );
    }

    private getAppServices(): IPcEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IPcEditorAppServices;
    }
}
